export const quickLinksConstants={
    list:{
        fields:{
            title:"QuickLinksTitle",
            logo:"QuickLinksLogo",
            url:"QuickLinksURL"
        }
    },
    camlQuery:{
    quickLinksHome:`
    <View>  
        <Query> 
            <OrderBy>
                <FieldRef Name='Modified' Ascending='FALSE' />
            </OrderBy> 
        </Query> 
        <ViewFields>
            <FieldRef Name='QuickLinksTitle' />
            <FieldRef Name='QuickLinksLogo' />
            <FieldRef Name='QuickLinksURL' />
        </ViewFields> 
    </View>`
},
    slash : "/"
}